<template>
    <div
        class="effects-skeleton-card"
        :class="{ 'effects-skeleton-card--overlay': overlay }"
        aria-hidden="true"
    >
        <div class="effects-skeleton-card__media effects-skeleton-shimmer"></div>
        <div
            v-if="showTitle"
            class="effects-skeleton-card__title effects-skeleton-shimmer"
            :class="variant === 'photo'
                ? 'effects-skeleton-card__title--photo'
                : 'effects-skeleton-card__title--video'"
        ></div>
    </div>
</template>

<script setup lang="ts">
withDefaults(
    defineProps<{
        variant?: 'video' | 'photo'
        showTitle?: boolean
        overlay?: boolean
    }>(),
    {
        variant: 'video',
        showTitle: true,
        overlay: false,
    }
)
</script>

<style scoped lang="less">
.effects-skeleton-card {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #161618;
}

.effects-skeleton-card--overlay {
    position: absolute;
    inset: 0;
    z-index: 4;
    pointer-events: none;
}

.effects-skeleton-card__media {
    position: absolute;
    inset: 0;
    background: #161618;
}

.effects-skeleton-card__title {
    position: absolute;
    left: 50%;
    bottom: 16px;
    z-index: 1;
    height: 16px;
    border-radius: 999px;
    transform: translateX(-50%);
    background: #161618;
}

.effects-skeleton-card__title--video {
    width: 42%;
    min-width: 88px;
    max-width: 176px;
}

.effects-skeleton-card__title--photo {
    width: 50%;
    min-width: 96px;
    max-width: 192px;
}

/* .effects-skeleton-shimmer {
    background-size: 200% 100%;
    animation: effects-skeleton-shimmer 1.6s ease-in-out infinite;
}

@keyframes effects-skeleton-shimmer {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
} */
</style>
